import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "lc_common-triangle-down",
  "use": "lc_common-triangle-down-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"lc_common-triangle-down\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.2 881l384-665H128.3z\" p-id=\"1587\" fill=\"#2c2c2c\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol